module.exports = __webpack_public_path__ + "img/3003501.1a53e8e5.svg";